// `/distributors/$id/orders` — таб «Заказы» в карточке тенанта для
// PLATFORM_ADMIN (PA-12, D17 §2.3).
//
// Рендерит существующий `OrdersScreen` в embedded-режиме с зафиксированным
// distributor-фильтром: PA видит только заказы конкретного тенанта, изменить
// фильтр через UI нельзя (toolbar не показывает distributor-select). Layout-
// route `distributors.$id.tsx` отвечает за `AdminShell`, breadcrumb, TabBar
// и `redirectIfNotPlatformAdmin` (наследуется child'ами через TanStack
// Router `beforeLoad`).
//
// PA view-only: backend через permission-gating (D17 §2.2) не пускает PA в
// мутации (cancel/edit-order). Frontend дополнительно полагается на embedded-
// флаг — если в `OrdersScreen` появятся action-меню, скрывать их нужно по
// тому же признаку.

import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { RetiredScreen } from '../components/RetiredScreen'

export const Route = createFileRoute('/distributors/$id/orders')({
  component: DistributorOrdersTab,
})

function DistributorOrdersTab() {
  const { id } = Route.useParams()
  const numericId = Number(id)
  if (!Number.isFinite(numericId)) {
    return (
      <RequireAuth>
        <div style={{ padding: 24, color: 'var(--color-text-secondary)' }}>
          Некорректный идентификатор дистрибьютора в URL.
        </div>
      </RequireAuth>
    )
  }
  return (
    <RequireAuth>
      <RetiredScreen embedded />
    </RequireAuth>
  )
}
